import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';

import * as ReactBootStrap from 'react-bootstrap';
import EstadoVacio from '../components/EstadoVacio';
import InformeAnexos from '../components/InformeAnexos';
import Buscar from '../tools/images/Buscar';
import '../tools/css/Home.css';
import '../tools/css/Anexos.css';

const ApiURL=process.env.REACT_APP_API_URL;

var buscar_anexo='';

class Anexos extends Component {

  informeRef = React.createRef();

  constructor(){
    super()
    this.state={
      loading:true,
      Anexos:[],
      Pager_Anexos:[],
      pager_infoanexos:'',
      buscar_anexos:'',
      ordenColumna:'',
      ordenDireccion:'asc'
    }
  }

  componentDidMount(){
    this.ListarAnexos();
  }

  ListarAnexos(){
    this.setState({ loading: this.state.loading = false })

    axios.get(ApiURL+"/api/Attach/GetAttachsInstitution?numeroPagina=1")
    .then((response) => {
      console.log(response);
      this.setState({Anexos: response.data.data})
      this.setState({Pager_Anexos: response.data.pager.items})
      this.setState({pager_infoanexos: response.data.pager.showData})
      this.setState({ loading: this.state.loading = true })
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading: this.state.loading = true })
    })
  }

  loadMoreDataAnexos(page_anexo){
    var page=page_anexo.pagina
    this.setState({ loading: this.state.loading = false })

    const busqueda = this.state.buscar_anexos
    axios.get(ApiURL+"/api/Attach/GetAttachsInstitution?numeroPagina="+page + (busqueda ? "&texto="+busqueda : ""))
    .then((response) => {
      console.log(response);
      this.setState({Anexos: response.data.data})
      this.setState({Pager_Anexos: response.data.pager.items})
      this.setState({pager_infoanexos: response.data.pager.showData})
      this.setState({ loading: this.state.loading = true })
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading: this.state.loading = true })
    })
  }

  searchDataAnexo(texto){
    this.setState({ loading: this.state.loading = false })

    axios.get(ApiURL+"/api/Attach/GetAttachsInstitution?numeroPagina=1&texto="+texto)
    .then((response) => {
      console.log(response);
      this.setState({Anexos: response.data.data})
      this.setState({Pager_Anexos: response.data.pager.items})
      this.setState({pager_infoanexos: response.data.pager.showData})
      this.setState({ loading: this.state.loading = true })
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading: this.state.loading = true })
    })
  }

  BuscarAnexo = (e) => {
    this.setState({buscar_anexos:e.target.value})
    buscar_anexo=e.target.value
    this.searchDataAnexo(buscar_anexo)
  }

  /**
   * El orden es solo del lado del cliente, sobre los anexos ya cargados en la
   * página actual (el buscador de arriba sí consulta el endpoint completo
   * vía ?texto=).
   */
  obtenerValorColumna = (anexo, columna) => {
    switch(columna){
      case 'id': return anexo.id
      case 'patientName': return anexo.patientName || ''
      case 'tipoAnexo': return (anexo.typeAttach && anexo.typeAttach.name) || ''
      case 'description': return anexo.description || ''
      case 'profesionalName': return anexo.profesionalName || ''
      case 'date': return anexo.date || ''
      default: return ''
    }
  }

  handleOrdenarColumna = (columna) => {
    this.setState((prevState) => {
      const mismaColumna = prevState.ordenColumna === columna
      return {
        ordenColumna: columna,
        ordenDireccion: mismaColumna && prevState.ordenDireccion === 'asc' ? 'desc' : 'asc'
      }
    })
  }

  renderIconoOrden = (columna) => {
    if(this.state.ordenColumna !== columna){
      return <i className="fas fa-sort anexos-th-icono"></i>
    }
    return this.state.ordenDireccion === 'asc'
      ? <i className="fas fa-sort-up anexos-th-icono anexos-th-icono--activo"></i>
      : <i className="fas fa-sort-down anexos-th-icono anexos-th-icono--activo"></i>
  }

  obtenerAnexosVisibles = () => {
    const { ordenColumna, ordenDireccion } = this.state

    let lista = this.state.Anexos

    if(ordenColumna){
      lista = [...lista].sort((a, b) => {
        const va = this.obtenerValorColumna(a, ordenColumna)
        const vb = this.obtenerValorColumna(b, ordenColumna)
        let comparacion

        if(ordenColumna==='id'){
          comparacion = Number(va) - Number(vb)
        }else if(ordenColumna==='date'){
          comparacion = moment(va).valueOf() - moment(vb).valueOf()
        }else{
          comparacion = String(va).localeCompare(String(vb), 'es', { sensitivity:'base' })
        }

        return ordenDireccion==='asc' ? comparacion : -comparacion
      })
    }

    return lista
  }

  render(){
    const anexosVisibles = this.obtenerAnexosVisibles()

    return (

      <div className="content-wrapper">

        <div className="col-12 col-sm-12">

          <div className="row">
            <div className="col-sm-12">
              <br/>
              <div className="text-center" id="title"><h6><b>ANEXOS DE LA INSTITUCIÓN</b></h6></div>
            </div>
          </div>

          <div className="card card-primary card-outline card-tabs">

            <div className="card-header p-0 pt-1 border-bottom-0">
              <ul className="nav nav-tabs" id="anexos-tabs-tab" role="tablist">
                <li className="nav-item">
                  <a className="nav-link active" id="anexos-tabs-lista-tab" data-toggle="pill" href="#anexos-tabs-lista" role="tab" aria-controls="anexos-tabs-lista" aria-selected="true"><i className="fas fa-paperclip"></i> Anexos</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="anexos-tabs-informe-tab" data-toggle="pill" href="#anexos-tabs-informe" role="tab" aria-controls="anexos-tabs-informe" aria-selected="false" onClick={()=>{this.informeRef.current && this.informeRef.current.dibujarGraficas()}}><i className="fas fa-chart-pie"></i> Informe</a>
                </li>
              </ul>
            </div>

            <div className="card-body">

              <div className="tab-content" id="anexos-tabs-tabContent">

                <div className="tab-pane fade show active" id="anexos-tabs-lista" role="tabpanel" aria-labelledby="anexos-tabs-lista-tab">

              <div className="d-flex justify-content-center">
                {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}
              </div>

              <div className="anexos-panel">

                <div className="row anexos-toolbar">
                  <div className="col-sm-4">
                    <div className="feed-search">
                      <Buscar/>
                      <input type="search" className="feed-search__input" placeholder="Buscar anexos..." name="buscar_anexos" onChange={this.BuscarAnexo}/>
                    </div>
                  </div>
                </div>

                <div className="anexos-table-wrap">
                  <table className="table table-bordered table-striped anexos-table">
                    <thead>
                      <tr>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('id')}>
                          <span className="anexos-th-titulo">ID Anexo {this.renderIconoOrden('id')}</span>
                        </th>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('patientName')}>
                          <span className="anexos-th-titulo">Paciente {this.renderIconoOrden('patientName')}</span>
                        </th>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('tipoAnexo')}>
                          <span className="anexos-th-titulo">Tipo de anexo {this.renderIconoOrden('tipoAnexo')}</span>
                        </th>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('description')}>
                          <span className="anexos-th-titulo">Descripción {this.renderIconoOrden('description')}</span>
                        </th>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('profesionalName')}>
                          <span className="anexos-th-titulo">Profesional {this.renderIconoOrden('profesionalName')}</span>
                        </th>
                        <th className="anexos-th-ordenable" onClick={()=>this.handleOrdenarColumna('date')}>
                          <span className="anexos-th-titulo">Fecha anexo {this.renderIconoOrden('date')}</span>
                        </th>
                        <th>Ver soporte</th>
                      </tr>
                    </thead>
                    <tbody>
                      {anexosVisibles.map(anexo=>{
                        return(
                          <tr key={anexo.id}>
                            <td>{anexo.id}</td>
                            <td>{anexo.patientName}</td>
                            <td>{anexo.typeAttach ? anexo.typeAttach.name : ''}</td>
                            <td>{anexo.description}</td>
                            <td>{anexo.profesionalName}</td>
                            <td><Moment format="YYYY/MM/DD HH:mm">{anexo.date}</Moment></td>
                            <td className="text-center">
                              <a href={ApiURL+"/api/Files?path="+anexo.path} target="_blank" rel="noopener noreferrer" title="Ver soporte" className="anexos-btn-ver">
                                <i className="fas fa-file-medical"></i>
                              </a>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>

                {anexosVisibles.length==0 ? (
                  <div className="anexos-empty">
                    <div className="d-flex justify-content-center"><EstadoVacio/></div>
                    <div className="d-flex justify-content-center"><h5><b>No hay anexos que mostrar</b></h5></div>
                  </div>
                ) : null}

                <div className="anexos-pagination-bar">
                  <span className="anexos-pager-info">{this.state.pager_infoanexos}</span>
                  <nav className="nav anexos-pagination">
                    <ul className="pagination">
                      {this.state.Pager_Anexos.map(page_anexo=>{
                        var activo=page_anexo.activo
                        activo = activo==true ? 'page-item active' : 'page-item'
                        return(
                          <li className={activo} key={page_anexo.pagina}>
                            <a className="nav-link" onClick={()=>{this.loadMoreDataAnexos(page_anexo)}}>{page_anexo.texto}</a>
                          </li>
                        )
                      })}
                    </ul>
                  </nav>
                </div>

              </div>

                </div>

                <div className="tab-pane fade" id="anexos-tabs-informe" role="tabpanel" aria-labelledby="anexos-tabs-informe-tab">
                  <InformeAnexos ref={this.informeRef} />
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>

    )
  }

}

export default Anexos;
